import { render, staticRenderFns } from "./OsLogo.vue?vue&type=template&id=5a09a469&scoped=true"
import script from "./OsLogo.vue?vue&type=script&lang=ts"
export * from "./OsLogo.vue?vue&type=script&lang=ts"
import style0 from "./OsLogo.vue?vue&type=style&index=0&id=5a09a469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a09a469",
  null
  
)

export default component.exports